module.exports = __webpack_public_path__ + "static/media/twitter.217ca08a.svg";